module.exports = __webpack_public_path__ + "static/img/logogif3.f236a4c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/logogif3.gif
// module id = roJj
// module chunks = 1